import { FlexCapacityTier } from '../types/Dashboard'
import { faIndustry, faBuilding, faChargingStation, IconDefinition } from '@fortawesome/free-solid-svg-icons'

export function getFlexTier(flexCapacityKw: number): FlexCapacityTier {
    if (flexCapacityKw > 1000) return 'high'
    if (flexCapacityKw >= 50) return 'medium'
    return 'low'
}

export function getAssetIcon(tier: FlexCapacityTier): IconDefinition {
    switch (tier) {
        case 'high': return faIndustry
        case 'medium': return faBuilding
        case 'low': return faChargingStation
    }
}
